import React, { useEffect, useState, useMemo } from "react";

import { useDispatch, useSelector } from "react-redux";
import { Button, Form, ProgressBar } from "react-bootstrap";
import { IKImage } from "imagekitio-react";
import _ from "lodash";
import cx from "classnames";

import { FileUploadButton } from "components/Buttons";
import { 
  deleteBrandKitMedia, 
  initiateBrandKitMediaUpload, 
  invalidateBrandKitMediaDeleteError, 
  invalidateBrandKitMediaUploadError, 
  searchBrandKitMedia, 
  updateBrandKitMediaUploadProgress, 
  uploadBrandKitMedia 
} from "actions/brandKit/media";
import Header from "../../components/Header";
import InfiniteScroll from "components/InfiniteScroll";
import DeleteModal from "../../components/DeleteModal";
import EmptyMessage from "../../components/EmptyMessage";
import { HandleMediaUploadError, MediaErrorMessage } from "../../components/ErrorToast";

import styles from "../brandkit.elements.module.scss";
import { createMixpanelEvent } from "actions/mixpanel";
import { MIXPANEL_BRANDKIT_CREATED, MIXPANEL_USER_LOGIN } from "constants/mixpanelEvents";
import TruncatedTextWithTooltip from "components/TruncatedTextWithTooltip";



const Options = [
  {
    name: "image",
    label: "Images",
  },
  {
    name: "video",
    label: "Videos",
  },
];

const IMAGE_CDN_ENDPOINT = process.env.REACT_APP_IMAGE_CDN;
const defaultContentImage = "/public/cleverstory/v2/static/default_card.jpg";


const MediaElement = () => {
  const dispatch = useDispatch();

  const [state, setState] = useState({
    active: 'image',
    selected: []
  })
  const multiple = true;
  const [showError, setShowError] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [toggleBrandElements, setToggleBrandElements] = useState(false);
  const [uploadStatus, setUploadStatus] = useState(false)
  const [uploadInstances, setUploadInstances] = useState([]);

  const paletteIds = useSelector((state) => _.get(state, "brandKit.activated.items", []));
  const uploads = useSelector(state => _.get(state, 'brandKit.media.uploads')) || [];
  const mediaList = useSelector(state => _.get(state, 'brandKit.media.items')) || [];
  const dataFetched = useSelector(state => _.get(state, 'brandKit.media.fetched'));
  const loading = useSelector(state => _.get(state, 'brandKit.media.loading'));
  const deleting = useSelector(state => _.get(state, 'brandKit.media.deleting'));
  const pagination = useSelector(state => _.get(state, 'brandKit.media.pagination'));
  const error = useSelector(state => _.get(state, 'brandKit.media.error'));
  const uploadingFail = useSelector(state => _.get(state, 'brandKit.media.uploadError', false));
  const errorType = useSelector(state => _.get(state,'brandKit.media.errorType'));
  const hasMoreItems = _.get(pagination, 'currentPage') < _.get(pagination, 'totalPages') - 1;

  const paletteId = useMemo(
    () => _.find(paletteIds, { type: "MEDIA" })?.id,
    [paletteIds]
  );

  const enabled = useMemo(
    () => _.find(paletteIds, { type: "MEDIA" })?.enabled,
    [paletteIds]
  );

  useEffect(()=>{
    if (enabled != toggleBrandElements) {
      setToggleBrandElements(enabled)
    }
  },[enabled])

  useEffect(() => {
    if(paletteIds){
      handleSearchMedia();
    }
  }, [paletteIds,toggleBrandElements])

  useEffect(() => {
    if (!loading && showDeleteModal && !deleting) {
      setShowDeleteModal(false);
      setState(state => {
        return {
          ...state,
          selected: []
        }
      })
    }
  }, [deleting]);

  useEffect(() => {
    if (error) {
      setShowError(true);
    }
  }, [error]);

  const handleTabChange = (active) => {
    setState(state => {
      return {
        active: active,
        selected: []
      }
    })
  }

  const handleSearchMedia = () => {
    if (paletteId) {
      const request = {
      palette: paletteId,
      target: null,
      mediaTypes: ['image', 'video'],
      page: 0,
      limit: 20,
      sort: 'modifiedDate',
      order: 'desc'
      };

      dispatch(searchBrandKitMedia(request));
   }
  }

  const loadMoreMedia = () => {
    const nextPage = pagination.currentPage + 1;
    if (nextPage >= pagination.totalPages) {
      return;
    }

    if (paletteId) {
      const request = {
      palette: paletteId,
      target: null,
      page: pagination.currentPage + 1,
      mediaTypes: ['image', 'video'],
      limit: 20,
      sort: 'modifiedDate',
      order: 'desc'
      };

      dispatch(searchBrandKitMedia(request));
    }  
  }

  const handleSelect = (media) => {
    var updated = [...state.selected];

    if (multiple) {
      const exists = updated.find(m => m.id === media.id) != null;
      if (exists) {
        updated = updated.filter(m => m.id !== media.id);
      } else {
        updated = [...updated, media];
      }
    } else {
      updated = [media];
    }
    
    setState(state => {
      return {
        ...state,
        selected: updated
      }
    })
  }

  const handleUploadInstanceChange = (instance) => {
    setUploadInstances((state) => {
      return state.map(item => {
        if (item.files[0].id === instance.files[0].id) {
          return instance
        }

        return item;
      })
    });
  }

  const handleErrorClose = () => {
    setShowError(false);
    dispatch(invalidateBrandKitMediaDeleteError());
  }

  const handleUploadErrorClose = () => {
    dispatch(invalidateBrandKitMediaUploadError());
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={cx(styles.categoriesList, "px-2")}>
          {Options.map((data) => (
            <span
              onClick={() => handleTabChange(data.name)}
              className={cx(
                styles.icons,
                state.active === data.name && styles.iconSelected
              )}
              key={data.name}
            >
              {data.label}
            </span>
          ))}
        </div>
        <div className={styles.liner}></div>
        <div className={styles.mainContainer}>
          <Header
            selectedCategory={state.active == 'image' ? "images" : "videos"}
            toggleBrandElements={toggleBrandElements}
            setToggleBrandElements={setToggleBrandElements}
            deleteHandler={() => setShowDeleteModal(true)}
            selectedItems={state.selected}
            loading={loading}
            paletteId={paletteId}
          >
            <MediaUploadButton
              paletteId={paletteId}
              state={state}
              setUploadStatus={setUploadStatus}
            />
          </Header>

          <div className={styles.mainContentWrapper}>
            <Component
             loading={loading}
             hasMoreItems={hasMoreItems}
             state={state}
             mediaList={mediaList}
             loadMoreMedia={loadMoreMedia}
             uploads={uploads}
             handleClick={handleSelect}
             dataFetched={dataFetched}
             showDeleteModal={showDeleteModal}
             setShowDeleteModal={setShowDeleteModal}
             deleting={deleting}
             uploadStatus={uploadStatus}
             setUploadStatus={setUploadStatus}
             onInstanceChange={handleUploadInstanceChange} 
            />
           {showError && _.size(error) > 0 &&
             <MediaErrorMessage message='The media cannot be deleted as it exists in one or more pages.' onClose={handleErrorClose} />
           }
           {uploadingFail && 
             <HandleMediaUploadError message={errorType} onClose={handleUploadErrorClose}/>
           }
          </div>
        </div>
      </div>
    </div>
  );
};

const Component = ({
  loading,
  hasMoreItems,
  state,
  mediaList,
  loadMoreMedia,
  uploads,
  handleClick,
  dataFetched,
  showDeleteModal,
  setShowDeleteModal,
  uploadStatus,
  setUploadStatus,
  deleting,
  onInstanceChange
}) => {

  const dispatch = useDispatch();
  const [emptyMessage, setEmptyMessage] = useState('')
  const imageTypes = [ "image/jpg", "image/jpeg", "image/png", "image/svg", "image/bmp", "image/gif", "image/svg+xml"];
  const videoTypes = ['video/mp4']

  useEffect(() => {
    const images = mediaList?.filter(item => item.type === 'image');
    const videos = mediaList?.filter(item => item.type === 'video');
  
    if (images.length === 0 && uploads.length === 0 && !uploadStatus ) {
      setEmptyMessage('image');
    }
  
    if (videos.length === 0 && uploads.length === 0 && !uploadStatus) {
      setEmptyMessage('video');
    }

    if(uploadStatus){
      setEmptyMessage('');
    }
  
    if (images.length > 0 && videos.length > 0) {
      setEmptyMessage('');
    }
  }, [mediaList, uploads, uploadStatus]);

  if (dataFetched && uploads.length === 0 && mediaList.length === 0) {
    return (
      <div className={styles.emptyMsgContainer}>
        <EmptyMessage/>
      </div>
    )
  }

  if (loading && mediaList?.length === 0) {
    return (
      <div className={styles.loaderContainer}>
        <label>Just a moon-ute... Scanning for media... </label>
      </div>
    )
  }

  const handleDelete = () => {
    const ids = state?.selected?.map(item => item.id);

    if (ids.length > 0) {
      dispatch(deleteBrandKitMedia(ids))
    }
  };

  return (
    <InfiniteScroll
      loading={loading}
      hasMore={hasMoreItems}
      loadMore={() => loadMoreMedia()}
    >
      <div className={styles.fontsWrapper}>
        {uploads?.map((upload) => {
          return (
            <MediaUploadIndicator
              key={upload.id}
              state={state}
              imageTypes={imageTypes}
              videoTypes={videoTypes}
              upload={upload}
              instance={upload.instance}
              setUploadStatus={setUploadStatus}
              onDimensionChange={(dimension) => {
                upload.instance.files[0].dimension = dimension;
                onInstanceChange(upload.instance);
              }}
          />
          )
        })}
        {state.active == 'image' && mediaList.map(media => {
          if (media.type !== 'image' && emptyMessage != 'image') {
            return null;
          }
          return (
            emptyMessage == 'image' ?
            (<EmptyMessage/>)
           : 
            (
              <div className={styles.mediaRecordsWrapper} key={media.id}>
                <div
                  className={cx(
                    styles.mediaRecordsBlock,
                    state.selected.some(data => data.id === media.id) &&
                      styles.mediaRecordsBlockSelected
                  )}
                  onClick={() => handleClick(media)}
                >
                  <IKImage
                    id={`media_image_${media.id}`}
                    className={styles.icon}
                    path={media.url || defaultContentImage}
                  />
                </div>
                <TruncatedTextWithTooltip className={styles.mediaName} content={media?.name || ''} maxWidth={165} placement='top'/>
              </div>
            )
          )
        })}
        {state.active == 'video' && mediaList.map(media => {
          if (media.type !== 'video' && emptyMessage != 'video') {
            return null;
          }
          return (
            (emptyMessage == 'video' && !loading) ?
              (<EmptyMessage/>)
            : 
              (
                <div className={styles.mediaRecordsWrapper} key={media.id}>
                  <div
                    className={cx(
                      styles.mediaRecordsBlock,
                      state.selected.some(data => data.id === media.id) &&
                        styles.mediaRecordsBlockSelected
                    )}
                    onClick={() => handleClick(media)}
                  >
                    <video
                      width={"100%"}
                      height={"100%"}
                      name={media.name}
                      className={styles.videoPlayer}
                      loop
                      muted
                      src={`${IMAGE_CDN_ENDPOINT}/${media.url}`}
                      onMouseOver={(event) => event.target.play()}
                      onMouseOut={(event) => event.target.pause()}
                    ></video>
                  </div>
                  <TruncatedTextWithTooltip className={styles.mediaName} content={media?.name || ''} maxWidth={165} placement='top'/>
                </div>
              )
          )
        })}
      </div>
      {showDeleteModal && (
        <DeleteModal
          showDeleteModal={true}
          message={`Are you sure you want to delete ${
            state?.selected?.length > 1
              ? `these ${state?.selected?.length} files`
              : "this file"
          }?`}
          title={`Delete ${state.active === "images" ? "Images" : "Videos"}`}
          isDeleting={deleting}
          backdrop={deleting}
          cancelHandler={() => setShowDeleteModal(false)}
          handleDeleteClick={handleDelete}
        />
      )}
    </InfiniteScroll>
  );
};

function MediaUploadIndicator({state, imageTypes, upload, videoTypes, instance, onDimensionChange, setUploadStatus}) {
 
  const imageRef = React.useRef(null);
  const videoRef = React.useRef(null);
  
  const previewFile = (file) => {
    if (!imageRef.current) {
      return;
    }

    var reader = new FileReader();

    reader.onloadend = function () {
      if (imageRef.current) {
        imageRef.current.src = reader.result;
      }
    }

    if (file) {
      reader.readAsDataURL(file);
    } else {
      imageRef.current.src = "";
    }
  }

  useEffect(() => {
    setUploadStatus(true);
  }, [upload])

  useEffect(() => {
    if (instance) {
      const file = instance.files[0];

      if (state.active === 'image' && imageRef?.current) {
        imageRef.current.onload = onImageLoad;
        previewFile(file);
      }

      if (state.active === 'video' && videoRef) {
        var video = videoRef.current;
        var sources = video.getElementsByTagName('source');
        sources[0].src = URL.createObjectURL(file);
      }
    }
  }, [imageRef, videoRef]);

  const onImageLoad = () => {
    const dimension = {
      width: imageRef.current.naturalWidth,
      height: imageRef.current.naturalHeight
    }

    if (onDimensionChange) {
      onDimensionChange(dimension);
    }
  }

  return (state.active == 'image' && imageTypes.includes(upload?.type)) ?
    <div
      className={cx(styles.fontBlock, styles.fontUploadingBlock)}
      key={upload.id}
    >
      <img ref={imageRef} style={{ display: "none" }}/>
      <div className={cx(styles.font, styles.fontUploading)}>
        {!upload?.processing ? (
          <ProgressBar variant="warning" now={upload.progress} />
        ) : (
          <div style={{ fontSize: "14px" }}>Processing...</div>
        )}
      </div>
      <TruncatedTextWithTooltip className={styles.mediaName} content={upload?.name || ''} maxWidth={165} placement='top'/>
    </div>
    : (state.active == 'video' && videoTypes.includes(upload?.type)) &&
    <div
      className={cx(styles.fontBlock, styles.fontUploadingBlock)}
      key={upload.id}
    >
      <video ref={videoRef} style={{ display: "none" }}>
        <source />
      </video>
      <div className={cx(styles.font, styles.fontUploading)}>
        {!upload?.processing ? (
          <ProgressBar variant="warning" now={upload.progress} />
        ) : (
          <div style={{ fontSize: "14px" }}>Processing...</div>
        )}
      </div>
      <TruncatedTextWithTooltip className={styles.mediaName} content={upload?.name || ''} maxWidth={165} placement='top'/>
    </div>;
}

const MediaUploadButton = ({ paletteId, state, setUploadStatus }) => {

  const dispatch = useDispatch();

  const handleUploadStart = (instances) => {
    instances.forEach(instance => {
      const upload = {
        id: instance.files[0].id,
        name: instance.files[0].name,
        type: instance.files[0].type,
        size: (instance.files[0].size / 1048576),
        progress: 0,
        instance: instance
      }

      dispatch(initiateBrandKitMediaUpload(upload));
    });
  }

  const handleUploadProgress = (file, progress) => {
    dispatch(updateBrandKitMediaUploadProgress(file.id, progress));
  }

  const handleUploadComplete = (info, file) => {
    const formats = ['image/jpg', 'image/jpeg', 'image/png', 'image/svg', 'image/bmp', 'image/gif', 'image/svg+xml', 'video/mp4']
    if (info && formats.includes(file.type)) {
      var request = {
        fileName: file.name,
        contentType: file.type,
        signedUrl: info.signedUrl,
        width: _.get(file, 'dimension.width'),
        height: _.get(file, 'dimension.height'),
        palette: paletteId,
        target: undefined,
      }

      if (file.type === 'video/mp4') {
        var video = document.createElement('video');

        video.onloadedmetadata = () => {
          request = {
            ...request,
            width: video.videoWidth,
            height: video.videoHeight
          }

          handleUploadMedia(request, file);
        };
        video.onerror = () => {

        };
        video.src = URL.createObjectURL(file);
      } else {
        handleUploadMedia(request, file);
      }
    }
  }

  const handleUploadMedia = (request, file) => {
    dispatch(uploadBrandKitMedia(file.id, request));
    setUploadStatus(false)

    var mixpanelPayload = {
      brandkit_element_type: "Images"
    }

    if(file.type === 'video/mp4'){
      mixpanelPayload = {
        brandkit_element_type: "Videos"
      }
    }

    dispatch(createMixpanelEvent(MIXPANEL_BRANDKIT_CREATED, mixpanelPayload));
  }

  return (
    <FileUploadButton
      className={cx(styles.upload)}
      name="mediaFile"
      multiple={true}
      accept={state.active === 'image' ?[
              "image/jpg",
              "image/jpeg",
              "image/png",
              "image/svg",
              "image/bmp",
              "image/gif",
              "image/svg+xml"]:
              "video/mp4"
        }
      onStart={handleUploadStart}
      onProgress={handleUploadProgress}
      onComplete={handleUploadComplete}
    >
      <Button className={styles.uploadButton}><i className="cleverstory-upload" />Upload Media</Button>
    </FileUploadButton>
  )
}

export default MediaElement;